import {FC, useMemo, useState} from 'react';
import {useMediaQuery} from '@mantine/hooks';

import {useSelector} from '~/store/hooks';
import NavLink from '~/common/NavLink/NavLink';
import {Icons, SidebarIcons} from '~/common/Icon';
import {UserType} from '~/services/types';
import {Permissions} from '~/services/account';
import CardBordered from '~/common/display/CardBordered/CardBordered';

import MyAdsLinks from './parts/MyAdsLinks';
import MyAccountLinks from './parts/MyAccountLinks';
import AccountSettingsLinks from './parts/AccountSettingsLinks';
import MyHotlinksPageLink from './parts/MyHotlinksPageLink';
import FinancesLinks from './parts/FinanceLinks';
import s from './styles.module.scss';

const MenuItems = {
  myAds: MyAdsLinks,
  myAccount: MyAccountLinks,
  accountSettings: AccountSettingsLinks,
  myHotlinks: MyHotlinksPageLink,
  finances: FinancesLinks,
};

interface LinksProps {
  isMenuLocked: boolean;
}

const Links: FC<LinksProps> = ({isMenuLocked}) => {
  const [activeItem, setActiveItem] = useState<keyof typeof MenuItems | null>(null);
  const isMobile = useMediaQuery('(max-width: 767px)');

  const profile = useSelector((state) => state.profile.data);
  const isShowImportApiMenu = useMemo(() => {
    if (!profile) {
      return false;
    }

    if (profile.userType === UserType.Regular) {
      return false;
    }

    return profile.permissions.reduce((acc, item) => {
      if (acc) {
        return acc;
      }

      return [Permissions.PUSH_CAMS, Permissions.PUSH_MODELS].includes(item);
    }, false);
  }, [profile]);

  if (activeItem) {
    const Component = MenuItems[activeItem];

    return <Component onClickBack={() => setActiveItem(null)} />;
  }

  return (
    <CardBordered className={s.card}>
      {profile?.userType !== UserType.Regular && (
        <NavLink
          icon={Icons.myAds}
          label="My Ads"
          carretRight
          disabled={isMenuLocked}
          onClick={() => setActiveItem('myAds')}
        />
      )}
{/*
      <NavLink
        icon={Icons.myAccount}
        label="My Account"
        carretRight
        disabled={isMenuLocked}
        onClick={() => setActiveItem('myAccount')}
      />
*/}

{/*
      <NavLink
        icon={Icons.accountSettings}
        label="Account Settings"
        carretRight
        disabled={isMenuLocked}
        onClick={() => setActiveItem('accountSettings')}
      />

*/}
      <NavLink
        icon={Icons.dollarBox}
        label="Finance"
        carretRight
        disabled={isMenuLocked}
        onClick={() => setActiveItem('finances')}
      />
{/*
      {profile?.hotlinksUrl && (
        <NavLink
          icon={Icons.myHotlinks}
          label="My Hotlink Page"
          disabled={isMenuLocked}
          href={profile?.hotlinksUrl}
        />
      )}
      {profile?.userType === UserType.Regular && (
        <NavLink
          icon={Icons.advertiseOnHot}
          disabled={isMenuLocked}
          label="Advertise on Hot"
          href="/profile#/advertise-on-hot"
        />
      )}
      <NavLink
        icon={Icons.homePlus}
        disabled
        label="Claim Business"
        href="/profile#/business-claim"
      />
      {profile?.userType !== UserType.Regular && (
        <NavLink
          icon={Icons.home}
          label="My Businesses"
          href="/profile#/my-business"
          disabled={isMenuLocked}
        />
      )}
*/}
{/*
      <NavLink
        icon={Icons.addBusiness}
        id="fm_desktop_add_business_menu_item"
        onClick={() => {
          if (isMobile) {
            window.location.href = '/add-business';
          } else {
            // TODO: make this popup on react and get rid of $.hotLoad
            $.hotLoad({
              url: '/site/add-business',
              container: $('#pjax_root'),
              fragment: `#add_business_root`,
              completeHotLoad() {
                $('body').addClass('popmod_body');
                $('#pjax_root').parent().addClass('popmod_visible');
              },
            });
            document.dispatchEvent(new Event('click'));
          }
        }}
        disabled={isMenuLocked}
        label="Add Business"
      />
*/}
      {isShowImportApiMenu && (
        <NavLink icon={SidebarIcons.impportApi} label="Import API" href="/profile#/import-api" />
      )}
{/*
      <NavLink icon={Icons.menuFaq} href="https://help.hot.com" label="FAQ" />
*/}
      <NavLink icon={Icons.logout} href="/logout" label="Logout" />
    </CardBordered>
  );
};

export default Links;
